export interface GetBookBoundCollectionsRequest {
  collectionId: number
}

export function GetBookBoundCollectionsRequestToJSON(
  value: GetBookBoundCollectionsRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined
  }
}
